// NOTE: this enum is a convenience for type-narrowing setting names at call sites.
// It is NOT the source of truth for which settings are exposed to the frontend —
// that is controlled by `screener_setting_definitions.is_fe_readable` in the DB.
// Consult the DB (or Retool) when introducing or auditing FE-exposed settings.
export enum ScreenerSettingName {
  // not in UserFacingScreenerSettings — ENG-15866
  LostReferralCleanUp = 'lost_referral_clean_up',
  RuleAndDataPullCategories = 'rule_and_data_pull_categories',
  BedBoardEnabled = 'bed_board',
  LoaAdmissionStatus = 'loa_admission_status',
  OverrideAiAnalysisResult = 'override_ai_analysis_result',
  // not in UserFacingScreenerSettings — ENG-15866
  EfaxInboxEnabled = 'efax_inbox',
  SkipReferralCreationForSpamFax = 'skip_referral_creation_for_spam_fax',
  SkipReferralCreationForNonReferralFax = 'skip_referral_creation_for_non_referral_fax',
  DisableExacareFrontend = 'disable_exacare_frontend',
  PushConditionsToPcc = 'push_conditions_to_pcc',
  ReferralOutbound = 'referral_outbound',
  BillingScreenerEnabled = 'billing_screener_enabled',
  EsignEnabled = 'esign_enabled',
  EsignCompletedDocumentSharingEnabled = 'esign_completed_document_sharing_enabled',
  EsignRequestCreationEnabled = 'esign_request_creation_enabled',
  InstanceBulkAction = 'instance_bulk_action',
  // not in UserFacingScreenerSettings — ENG-15866
  FacilityTypeAdmissionStatusResolution = 'facility_type_admission_status_resolution',
  ShowReferralsBeyondAccess = 'show_referrals_beyond_access',
  BulkTaskCreate = 'bulk_task_create',
  DefaultPrimaryOwnerOnReviewStageChange = 'default_primary_owner_on_review_stage_change',
  ServiceAreaEnabled = 'service_area_enabled',
  DisplayInnOonStatus = 'display_inn_oon_status',
  ExpandedPayerListRatio = 'expanded_payer_list_ratio',
  BedHold = 'bed_hold',
  PhoneAgent = 'phone_agent',
  WaitlistEnabled = 'waitlist_enabled',
  NoBedSelectionBedboard = 'no_bed_selection_bedboard',
  PalReauths = 'pal_reauths',
  PccDataRelayEnabled = 'pcc_data_relay_enabled',
  PccSyncV2Ingestion = 'pcc_sync_v2_ingestion',
  ResidentsPccUpdates = 'residents_pcc_updates',
  PalPreauth = 'pal_preauth',
  PalPreauthBenefitsVerificationRequired = 'pal_preauth_benefits_verification_required',
  MedicareMedicaidNetworkStatusEnabled = 'medicare_medicaid_network_status_enabled',
  ScreenerCriteriaCountLimit = 'screener_criteria_count_limit',
  ScreenerMedicationRulesCountLimit = 'screener_medication_rules_count_limit',
  ShowSmsNotificationsCheckbox = 'show_sms_notifications_checkbox',
  MultipleFaxNumbersPerSource = 'multiple_fax_numbers_per_source',
  KanbanPresetBar = 'kanban_preset_bar',
  PdpmEstimatorV2 = 'pdpm_estimator_v2',
  FacTagCriteriaTargeting = 'fac_tag_criteria_targeting',
  PendoProductTours = 'pendo_product_tours',
  ChameleonProductTours = 'chameleon_product_tours',
  UserpilotProductTours = 'userpilot_product_tours'
}
